const URL_SCHEME_REGEX = /^[a-z][a-z0-9+.-]*:\/\//i;
const DOMAIN_LIKE_REGEX = /^[^\s/]+\.[^\s]+/;

export function normalizeOptionalUrl(value: string | null | undefined): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();

  if (!trimmed) {
    return undefined;
  }

  if (URL_SCHEME_REGEX.test(trimmed)) {
    return trimmed;
  }

  if (DOMAIN_LIKE_REGEX.test(trimmed)) {
    return `https://${trimmed}`;
  }

  return trimmed;
}

export function normalizeOptionalUrlInput(value: unknown): unknown {
  if (typeof value !== 'string' && value !== null && value !== undefined) {
    return value;
  }

  return normalizeOptionalUrl(typeof value === 'string' ? value : undefined);
}
